module.exports = __webpack_public_path__ + "img/rb.9ee90453.png";